import React from 'react';
import style from './style.scss';
import Product from 'components/partials/product';

class ListItemCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  render() {
    return (
      <section className="list-item-category-S">
        <div className='wrap-list-item'>
          {
            this.state.data.map((productItem,i) => {
              let item = {
                id: productItem.id,
                ...productItem.attributes
              };
              return (
                <div className='product-wrap' key={i}>
                  <Product enableAddProduct={true} {...item}/>
                </div>
              );
            })
          }
        </div>
      </section>
    );
  }
}

ListItemCategory.defaultProps = {
  data: []
};

export default ListItemCategory;



// WEBPACK FOOTER //
// ./components/category-detail/list-category-item/ListItemCategory.jsx